import React from "react";
import Table from "react-bootstrap/Table";
import { isMobile } from "react-device-detect";

const getTermRow = (term, noOfWeeks, date1, date2) => {
  return (
    <tr style={{ textAlign: "center" }}>
      <td colSpan={4}>{term}</td>
      <td colSpan={4}>{noOfWeeks}</td>
      {isMobile && (
        <td colSpan={1}>
          <div>{date1 + " to"}</div>
          <div> {date2}</div>
        </td>
      )}
      {!isMobile && <td colSpan={1}>{date1 + " to " + date2}</td>}
    </tr>
  );
};

const ImportantDates = () => {
  return (
    <>
      <div style={{ marginTop: "60px" }}></div>
    </>
  );
};

export default ImportantDates;
